import qs from 'qs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Profile from './modules/Profile';
import LoginView from './views/LoginView';
import RegisterView from './views/RegisterView';
import ProfileView from './views/ProfileView';
import ProfileDetailView from './views/ProfileView/Detail';
import './kit/index.scss';
import NeedSubscriptionModal from './components/NeedSubscriptionModal';
import AccountView from './views/AccountView';
import { NotificationCenter } from './kit';
import CommunityView from './views/CommunityView';
import EventView from './views/EventView';
import EventDetailView from './views/EventView/Detail';
import FullscreenMessage from './components/FullscreenMessage';
import VideoPopup from './modules/VideoPopup';
import PostModal from './modules/Timeline/PostModal';

if (window.location.search.includes('_sso')) {
    const sso = qs.parse(window.location.search.substring(1));
    if (sso && sso._sso) {
        localStorage.setItem('accessToken', sso._sso as string);
    }
}

const register = document.getElementById('react-register') as HTMLElement;
if (register) ReactDOM.createRoot(register).render(<RegisterView title={register.dataset.title || ''} />);

const login = document.getElementById('react-login') as HTMLElement;
if (login) ReactDOM.createRoot(login).render(<LoginView title={login.dataset.title || ''} />);

if (localStorage.getItem('accessToken')) {
    const profile = document.getElementById('react-profile') as HTMLElement;
    if (profile) {
        profile.style.flex = '1';
        profile.style.justifyContent = 'flex-end';
        ReactDOM.createRoot(profile).render(<Profile />);
    }
}

// util
const util = document.getElementById('react-util') as HTMLElement;
if (util) {
    ReactDOM.createRoot(util).render(<>
        <NeedSubscriptionModal />
        <NotificationCenter />
        <FullscreenMessage />
        <PostModal />
        {localStorage.getItem('accessToken') && !localStorage.getItem('first-time') && <VideoPopup />}
    </>);
}

// pages
const community = document.getElementById('react-community') as HTMLElement;
if (community) ReactDOM.createRoot(community).render(<CommunityView />);

const events = document.getElementById('react-events') as HTMLElement;
if (events) ReactDOM.createRoot(events).render(<EventView />);
const eventDetail = document.getElementById('react-event-detail') as HTMLElement;
if (eventDetail) ReactDOM.createRoot(eventDetail).render(<EventDetailView />);

const profiles = document.getElementById('react-profiles') as HTMLElement;
if (profiles) ReactDOM.createRoot(profiles).render(<ProfileView />);

const profileDetail = document.getElementById('react-profile-detail') as HTMLElement;
if (profileDetail) ReactDOM.createRoot(profileDetail).render(<ProfileDetailView permalink={profileDetail.dataset.slug || ''} />);

const account = document.getElementById('react-account') as HTMLElement;
if (account) ReactDOM.createRoot(account).render(<AccountView />);
